import * as Immutable from 'immutable';
import moment from 'moment';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router';

import { StateType } from '../../reducers';
import { EventsProps } from '../../reducers/DashboardReducer/EventsReducer/EventsReducer.types';
import {
  eventsDataCalendarEventsSelector,
  eventsDataIsFetchingOptionsSelector,
  eventsDataIsFetchingSelector,
  eventsDataLanguageOptionsSelector,
} from '../../reducers/Events/DataReducer/DataSelector';
import { BaseFiltersOptions } from '../../reducers/Events/FiltersReducer/FiltersReducer.types';

import Context from './Context';
import './Events.scss';

interface EventsMainStateProps {
  data: Immutable.List<Immutable.Record<EventsProps>>;
  isFetching: boolean;
  isFetchingOptions: boolean;
  languageOptions: Immutable.List<BaseFiltersOptions>;
}

interface EventsMainProps {
  pathId?: string;
  handleToogleEventsCards: (event: string) => any;
  handleCloseEventsCards: () => any;
  children: React.ReactNode;
}

function EventsMain({
  data,
  isFetching,
  isFetchingOptions,
  languageOptions,
  children,
  pathId,
}: EventsMainStateProps & EventsMainProps & RouteComponentProps<{}>) {
  const [selectedDate, setSelectedDate] = useState<moment.Moment>(moment());
  const [eventsOpen, setEventsOpen] = useState<Immutable.List<string>>(Immutable.List());
  const [highlightedId, setHighlightedId] = useState<null | string>(null);

  const handleToogleEventsCards = (id: string) => {
    if (eventsOpen.includes(id)) {
      setEventsOpen(eventsOpen.filter(event => event !== id));
    } else {
      setEventsOpen(eventsOpen.concat(id));
    }
  };

  useEffect(() => {
    if (data.size > 0 && !isFetching && pathId) {
      const selectedEvent = data.find(currentEvent => currentEvent.get('id') === pathId);
      if (selectedEvent) {
        setSelectedDate(moment(selectedEvent.get('start')).startOf('month'));
        if (!eventsOpen.includes(pathId)) {
          setEventsOpen(eventsOpen.concat(pathId));
        }
        setHighlightedId(pathId);
      }
    }
  }, [isFetching, data.size, pathId]);

  const handleSelectDate = (currentDate: moment.Moment): any => {
    setSelectedDate(currentDate);
    setHighlightedId(null);
  };

  const handleCloseEventsCards = () => {
    setEventsOpen(Immutable.List());
  };

  const handleHighlightFinish = () => {
    setHighlightedId(null);
  };

  function getEvents() {
    return data.filter((event: any) => moment(selectedDate).isSame(event.get('start'), 'month'));
  }

  return (
    <Context.Provider
      value={{
        currentDate: selectedDate,
        isFetching,
        isFetchingOptions,
        selectDate: handleSelectDate,
        data: getEvents(),
        languageOptions,
        eventsOpen,
        handleToogleEventsCards: handleToogleEventsCards,
        handleCloseEventsCards: handleCloseEventsCards,
        highlightedId: highlightedId,
        onHighlightFinish: handleHighlightFinish,
      }}
    >
      {children}
    </Context.Provider>
  );
}
const mapStateToProps = (state: StateType): EventsMainStateProps => ({
  // @ts-ignore
  data: eventsDataCalendarEventsSelector(state),
  // @ts-ignore
  isFetching: eventsDataIsFetchingSelector(state),
  // @ts-ignore
  isFetchingOptions: eventsDataIsFetchingOptionsSelector(state),
  // @ts-ignore
  languageOptions: eventsDataLanguageOptionsSelector(state),
});

export default withRouter(connect<EventsMainStateProps, {}, {}, StateType>(mapStateToProps, {})(EventsMain));
